<!--
 * @Description: 
 * @Author: xutao
 * @Date: 2020-11-13 14:20:25
 * @LastEditors: xutao
 * @LastEditTime: 2021-02-04 14:32:43
-->
<template>
  <div class="home">
    <img class="lark" src="../../images/Lark20210204-141419.jpeg"/>
  </div>
</template>

<script>
export default {
  name: 'detail'
}
</script>

<style scoped>
  .lark{
    width: 100%;
    height: 100%;
  }
</style>
